var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"skeleton--container"},_vm._l((_vm.skeleton),function(event){return _c('div',{key:event.id,staticClass:"card"},[_c('div',{staticClass:"card__img-holder"}),_c('div',{staticClass:"card__content"})])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }